import { render, staticRenderFns } from "./PersonalProfilePage.vue?vue&type=template&id=2d9473b6&scoped=true&"
import script from "./PersonalProfilePage.vue?vue&type=script&lang=js&"
export * from "./PersonalProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9473b6",
  null
  
)

export default component.exports